module.exports = __webpack_public_path__ + "img/엘드리치.30cbf8de.png";